/* London Labs · site.js */
/* The catalogue, read from the live store. */
window.LL_CATALOGUE = window.LL_CATALOGUE || [];

var LL_CAT_STATE = null;

/* Pull a value off the first option whose name matches. */
function LL_opt(p, re) {
  var names = p.options || [];
  for (var i = 0; i < names.length; i++) {
    var n = names[i], name = (n && n.name) || n;
    if (re.test(String(name))) {
      if (n && n.values) return n.values;
      return (p.variants || []).map(function (v) { return v['option' + (i + 1)]; });
    }
  }
  return [];
}

function LL_map(p) {
  /* /products.json gives tags as a list, /products/<h>.json as a comma string. */
  if (typeof p.tags === 'string') { p.tags = p.tags ? p.tags.split(/\s*,\s*/) : []; }
  var title = String(p.title || '').toLowerCase();
  var hay = (title + ' ' + (p.tags || []).join(' ') + ' ' + (p.product_type || '')).toLowerCase();
  var variants = p.variants || [];
  var prices = variants.map(function (v) { return parseFloat(v.price) || 0; });
  var price = prices.length ? Math.min.apply(Math, prices) : 0;

  /* Title first: tags are inconsistent (e.g. "Nitrile Free", wrong colours). */
  var mil = /(\d+(?:\.\d+)?)\s*mil/.exec(title) || /(\d+(?:\.\d+)?)\s*mil/.exec(hay);
  var material = /vinyl|nitrile|latex|poly|neoprene/.exec(title) || /vinyl|nitrile|latex|poly|neoprene/.exec(hay);
  var colours = LL_opt(p, /colou?r/i).filter(Boolean);
  if (!colours.length) {
    var tc = /sky blue|cobalt blue|cotton candy|blue|black|clear|white|pink|purple|green|orange/.exec(title);
    if (tc) { colours = [tc[0] === 'cotton candy' ? 'pink' : tc[0]]; }
  }

  return {
    handle: p.handle,
    url: '/products/' + p.handle,
    image: (p.images && p.images[0] && p.images[0].src) || '',
    alt: p.title || '',
    counts: LL_opt(p, /count|pack|case/i).filter(Boolean),
    title: p.title,
    shortTitle: String(p.title).split(/[,–—|]/)[0].trim(),
    brand: p.vendor || '',
    material: material ? material[0] : '',
    sku: (variants[0] && variants[0].sku) || '',
    mil: mil ? parseFloat(mil[1]) : null,
    colour: (colours[0] || '').toLowerCase(),
    colours: colours.map(function (c) { return String(c).toLowerCase(); }),
    sizes: LL_opt(p, /size/i).filter(Boolean),
    price: price,
    inStock: variants.some(function (v) { return v.available; }),
    /* Tags and product type are the industry record. */
    industries: (p.tags || []).concat(p.product_type ? [p.product_type] : []),
    hay: hay,
    /* Best like-for-like saving: each variant against its own compare-at price. */
    savingsPct: variants.reduce(function (m, v) {
      var c = parseFloat(v.compare_at_price) || 0, pr = parseFloat(v.price) || 0;
      return c > pr ? Math.max(m, Math.round((c - pr) * 100 / c)) : m;
    }, 0)
  };
}

function LL_catalogue(then) {
  if (LL_CAT_STATE) { LL_CAT_STATE.then(then || function () {}); return LL_CAT_STATE; }

  LL_CAT_STATE = new Promise(function (resolve) {
    if (!window.fetch) { resolve(window.LL_CATALOGUE); return; }

    var out = window.LL_CATALOGUE;

    function page(n) {
      fetch('/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (body) {
          var list = (body && body.products) || [];
          list.forEach(function (p) { out.push(LL_map(p)); });
          /* A short page is the last page. */
          if (list.length === 250 && n < 20) { page(n + 1); } else { resolve(out); }
        })
        .catch(function () { resolve(out); });
    }
    page(1);
  });

  LL_CAT_STATE.then(then || function () {});
  return LL_CAT_STATE;
}

(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CAT = window.LL_CATALOGUE || [];

  var money = function (n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  }); };

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* Focus trap shared by the mega menu, the mobile drawer and quick view.
     Returns a release function. */
  function trap(container) {
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var f = $$(FOCUSABLE, container).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  function byHandle(h) {
    for (var i = 0; i < CAT.length; i++) if (CAT[i].handle === h) return CAT[i];
    return null;
  }


  /* 02a · Sticky header state */
  (function () {
    var head = $('[data-head]');
    if (!head) return;
    var ticking = false;
    function check() {
      head.classList.toggle('is-stuck', window.scrollY > 24);
      ticking = false;
    }
    // Overlay mode is driven by the hero engine; this handler only
    // supplies the ordinary sticky state for pages without a hero.
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    check();
  })();

  /* 02b · Mega menus */
  (function () {
    var triggers = $$('[data-mega-for]');
    if (!triggers.length) return;
    var openId = null, release = null, closeTimer = null;

    function panel(id) { return $('#' + id); }

    function close(returnFocus) {
      if (!openId) return;
      var p = panel(openId);
      var t = triggers.filter(function (x) { return x.dataset.megaFor === openId; })[0];
      if (p) p.setAttribute('data-open', 'false');
      if (t) {
        t.setAttribute('aria-expanded', 'false');
        if (returnFocus) t.focus();
      }
      if (release) { release(); release = null; }
      openId = null;
    }

    function open(id) {
      if (openId === id) return;
      close(false);
      var p = panel(id);
      var t = triggers.filter(function (x) { return x.dataset.megaFor === id; })[0];
      if (!p || !t) return;
      p.setAttribute('data-open', 'true');
      t.setAttribute('aria-expanded', 'true');
      release = trap(p);
      openId = id;
    }

    triggers.forEach(function (t) {
      var id = t.dataset.megaFor;
      var p = panel(id);
      if (!p) return;

      t.addEventListener('click', function (e) {
        e.preventDefault();
        openId === id ? close(true) : open(id);
      });
      t.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(id); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open(id);
          var f = $$(FOCUSABLE, p)[0];
          if (f) f.focus();
        }
      });

      [t, p].forEach(function (el) {
        el.addEventListener('mouseleave', function () {
          closeTimer = setTimeout(function () { close(false); }, 180);
        });
        el.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      });

      p.addEventListener('keydown', function (e) {
        var items = $$('.mega__item, .mega__feature a, .mega__foot a, .mega__foot button', p);
        var at = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && at > -1) { e.preventDefault(); (items[at + 1] || items[0]).focus(); }
        if (e.key === 'ArrowUp' && at > -1) { e.preventDefault(); (items[at - 1] || items[items.length - 1]).focus(); }
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
    document.addEventListener('click', function (e) {
      if (!openId) return;
      if (e.target.closest('#' + openId) || e.target.closest('[data-mega-for="' + openId + '"]')) return;
      close(false);
    });
  })();

  /* 02c · Mobile drawer navigation */
  (function () {
    var nav = $('[data-mnav]');
    var scrim = $('[data-site-scrim]');
    if (!nav || !scrim) return;
    var last = null, release = null;

    function open() {
      last = document.activeElement;
      nav.hidden = false; scrim.hidden = false;
      requestAnimationFrame(function () {
        nav.classList.add('is-open');
        scrim.classList.add('is-open');
        var x = $('[data-mnav-x]', nav);
        if (x) x.focus();
      });
      release = trap(nav);
      document.body.style.overflow = 'hidden';
    }
    function close() {
      nav.classList.remove('is-open');
      scrim.classList.remove('is-open');
      document.body.style.overflow = '';
      if (release) { release(); release = null; }
      setTimeout(function () {
        nav.hidden = true;
        if (!$('.qv.is-open')) scrim.hidden = true;
        if (last) last.focus();
      }, 250);
    }

    $$('[data-mnav-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-mnav-x]').forEach(function (b) { b.addEventListener('click', close); });
    scrim.addEventListener('click', function () { if (nav.classList.contains('is-open')) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });

    // Accordions. Closed by default so the list is scannable; one open at a time.
    $$('[data-acc]', nav).forEach(function (t) {
      t.addEventListener('click', function () {
        var p = $('#' + t.getAttribute('aria-controls'));
        var on = t.getAttribute('aria-expanded') === 'true';
        $$('[data-acc]', nav).forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
          var op = $('#' + o.getAttribute('aria-controls'));
          if (op) op.hidden = true;
        });
        if (!on) { t.setAttribute('aria-expanded', 'true'); if (p) p.hidden = false; }
      });
    });
  })();


  /* 02e · Site-wide search drawer */
  (function () {

    var triggers = $$('[data-search-open]');
    if (!triggers.length) {
      triggers = $$('.head__acts a[href$="/search"], .head__acts a[href$="/search"]');
    }
    if (!triggers.length || !CAT.length) return;

    var LIMIT = 12;
    var searchHref = triggers[0].getAttribute('href') || '/search';

    var scrim = document.createElement('div');
    scrim.className = 'scrim';
    scrim.setAttribute('data-srch-scrim', '');
    scrim.hidden = true;

    var panel = document.createElement('aside');
    panel.className = 'drawer drawer--srch';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'srch-drawer-title');
    panel.hidden = true;
    panel.innerHTML =
      '<header class="drawer__head">' +
        '<div>' +
          '<p class="drawer__title" id="srch-drawer-title">Search the catalogue</p>' +
          '<p class="mono drawer__sub" data-srch-count>' + CAT.length + ' products</p>' +
        '</div>' +
        '<button class="drawer__x" type="button" data-srch-x aria-label="Close search">' +
          '<svg width="18" height="18" aria-hidden="true"><use href="#ic-x"></use></svg>' +
        '</button>' +
      '</header>' +
      '<div class="drawer__field">' +
        '<form class="search" role="search" action="' + esc(searchHref) + '" method="get">' +
          '<label class="sr-only" for="srch-drawer-q">Search gloves by name, material or SKU</label>' +
          '<input class="drawer__q" id="srch-drawer-q" name="q" type="search" ' +
            'placeholder="Search nitrile, 8 mil, black&hellip;" autocomplete="off" ' +
            'aria-describedby="srch-drawer-count" data-srch-q>' +
          '<button class="search__go" type="submit" aria-label="Search">' +
            '<svg width="18" height="18" aria-hidden="true"><use href="#ic-search"></use></svg>' +
          '</button>' +
        '</form>' +
      '</div>' +
      '<div class="drawer__body drawer__body--srch" data-srch-list></div>' +
      '<footer class="drawer__foot">' +
        '<a class="notch notch--quiet" data-srch-all href="' + esc(searchHref) + '">' +
          '<span class="notch__label">Open the full search page</span>' +
          '<span class="notch__chip"><svg width="20" height="20" aria-hidden="true"><use href="#ic-arrow"></use></svg></span>' +
        '</a>' +
      '</footer>';

    document.body.appendChild(scrim);
    document.body.appendChild(panel);

    var input = $('[data-srch-q]', panel);
    var list = $('[data-srch-list]', panel);
    var counter = $('[data-srch-count]', panel);
    var allLink = $('[data-srch-all]', panel);
    counter.id = 'srch-drawer-count';

    var last = null, release = null, openState = false;

    function hay(p) {
      return (p.shortTitle + ' ' + p.title + ' ' + p.brand + ' ' + p.material + ' ' +
              p.sku + ' ' + (p.mil ? p.mil + ' mil' : '') + ' ' +
              (p.colours || []).join(' ') + ' ' + (p.sizes || []).join(' ') + ' ' +
              (p.industries || []).join(' ')).toLowerCase();
    }

    function hits(q) {
      var t = q.trim().toLowerCase();
      if (!t) return null;                     // null = "nothing typed yet"
      return CAT.filter(function (p) { return hay(p).indexOf(t) > -1; });
    }

    function row(p) {
      return '<a class="suggest__item suggest__item--media" href="' + esc(p.url) + '">' +
        '<img src="' + esc(p.image) + '" alt="" width="44" height="44" loading="lazy" decoding="async">' +
        '<span class="suggest__name">' + esc(p.shortTitle) + '</span>' +
        '<span>' + money(p.price) + '</span></a>';
    }

    function render() {
      var q = input.value.trim();
      var found = hits(q);

      if (found === null) {
        counter.textContent = CAT.length + ' products';
        list.innerHTML =
          '<div class="empty">' +
            '<div class="empty__art"><svg width="26" height="26" aria-hidden="true"><use href="#ic-search"></use></svg></div>' +
            '<p class="empty__title">Search all ' + CAT.length + ' products</p>' +
            '<p class="empty__body">By name, brand, material, thickness or SKU &mdash; ' +
              '&ldquo;nitrile&rdquo;, &ldquo;8 mil&rdquo;, &ldquo;GRIPXX&rdquo;.</p>' +
          '</div>';
        allLink.setAttribute('href', searchHref);
        return;
      }

      counter.textContent = found.length === 1
        ? '1 result'
        : found.length + ' results';

      list.innerHTML = found.length
        ? found.slice(0, LIMIT).map(row).join('') +
          (found.length > LIMIT
            ? '<p class="drawer__more">' + (found.length - LIMIT) +
              ' more on the full search page.</p>'
            : '')
        : '<div class="empty">' +
            '<div class="empty__art"><svg width="26" height="26" aria-hidden="true"><use href="#ic-search"></use></svg></div>' +
            '<p class="empty__title">No products match &mdash; try a material, a size, or a SKU</p>' +
            '<p class="empty__body">Nothing in the catalogue matches &ldquo;' + esc(q) + '&rdquo;. ' +
              'The whole range is 29 lines, so a broad word finds more than a precise one.</p>' +
          '</div>';

      allLink.setAttribute('href', searchHref + '?q=' + encodeURIComponent(q));
    }

    function open(ev) {
      if (ev) ev.preventDefault();
      if (openState) { input.focus(); input.select(); return; }
      openState = true;
      last = document.activeElement;
      panel.hidden = false; scrim.hidden = false;
      /* Seed from whichever header field the reader has already typed in,
         so the icon is never a reset. */
      var seed = $('.head__search .search input') || $('[data-site-search]');
      if (seed && seed.value.trim() && !input.value.trim()) input.value = seed.value;
      render();
      /* First open pays for the catalogue; later ones are instant. */
      LL_catalogue(function () { if (openState) render(); });
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        scrim.classList.add('is-open');
        input.focus();
        input.select();
      });
      release = trap(panel);
      document.body.style.overflow = 'hidden';
    }

    function close() {
      if (!openState) return;
      openState = false;
      panel.classList.remove('is-open');
      scrim.classList.remove('is-open');
      document.body.style.overflow = '';
      if (release) { release(); release = null; }
      var done = function () {
        panel.hidden = true;
        scrim.hidden = true;
        if (last && last.focus) last.focus();
      };
      /* --t-drawer is 240ms. Under reduced motion there is no transition
         to wait out, so the DOM is put back on the same tick. */
      reduced.matches ? done() : setTimeout(done, 240);
    }

    triggers.forEach(function (t) { t.addEventListener('click', open); });
    $('[data-srch-x]', panel).addEventListener('click', close);
    scrim.addEventListener('click', close);
    input.addEventListener('input', render);
    /* Enter goes to the full page rather than reloading nothing. */
    $('form', panel).addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });

    document.addEventListener('keydown', function (e) {
      if (openState && e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (openState) return;

      var mod = e.metaKey || e.ctrlKey;
      if (mod && e.key.toLowerCase() === 'k') { open(e); return; }

      /* "/" is a shortcut only when it is not a character the reader is
         typing into something. */
      if (e.key === '/' && !mod && !e.altKey) {
        var a = document.activeElement;
        var tag = a ? (a.tagName || '').toLowerCase() : '';
        if (tag === 'input' || tag === 'textarea' || tag === 'select' ||
            (a && a.isContentEditable)) return;
        open(e);
      }
    });
  })();

  /* 09 · Featured products — rendered from the real catalogue */
  var saved = {};
  try { saved = JSON.parse(localStorage.getItem('ll-saved') || '{}'); } catch (err) { saved = {}; }
  function persistSaved() {
    try { localStorage.setItem('ll-saved', JSON.stringify(saved)); } catch (err) {}
  }

  function unitPrice(p) {
    if (!p.heroCount) return null;
    return '$' + (p.price / p.heroCount).toFixed(3);
  }

  function stockMarkup(p) {
    return p.inStock
      ? '<span class="stock"><span class="dot dot--live"></span>In stock · ships today</span>'
      : '<span class="stock stock--low"><span class="dot dot--amber"></span>Backorder · 5–7 days</span>';
  }

  (function () {
    $$('[data-site-fav]').forEach(function (b) {
      b.setAttribute('aria-pressed', saved[b.dataset.siteFav] ? 'true' : 'false');
    });
  })();

  function bindStepper(st) {
    var input = $('.stepper__value', st);
    if (!input || st.dataset.bound) return;
    st.dataset.bound = '1';
    var min = parseInt(st.dataset.min, 10) || 1;
    var max = parseInt(st.dataset.max, 10) || 99;
    function sync() {
      var v = parseInt(input.value, 10) || min;
      v = Math.max(min, Math.min(max, v));
      input.value = v;
      $$('[data-step]', st).forEach(function (b) {
        b.disabled = (b.dataset.step === '-1' && v <= min) || (b.dataset.step === '1' && v >= max);
      });
      input.classList.remove('is-bumped');
      void input.offsetWidth;
      input.classList.add('is-bumped');
      setTimeout(function () { input.classList.remove('is-bumped'); }, 220);
    }
    $$('[data-step]', st).forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || min) + parseInt(b.dataset.step, 10);
        sync();
      });
    });
    input.addEventListener('change', sync);
    sync();
  }

  /* --- View switch · density only, never the result set ------ */
  (function () {

    var grids = $$('[data-site-featured], [data-cat-grid], [data-srch-grid], .ind__grid');
    if (!grids.length) return;
    $$('[data-site-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.dataset.siteView;
        grids.forEach(function (g) { g.setAttribute('data-view', v); });
        $$('[data-site-view]').forEach(function (o) {
          o.setAttribute('aria-pressed', String(o === b));
        });
        try { localStorage.setItem('ll-view', v); } catch (e) {}
      });
    });
    /* Remember the choice across pages — a buyer who switched to list
       on collection expects list on search too. */
    try {
      var saved = localStorage.getItem('ll-view');
      if (saved === 'list') {
        var lb = $('[data-site-view="list"]');
        if (lb) lb.click();
      }
    } catch (e) {}
  })();

  (function () {
    var grid = $('[data-srch-grid]');
    var sel = $('[data-srch-sort]');
    if (!grid || !sel) return;
    var original = [].slice.call(grid.children);
    sel.addEventListener('change', function () {
      var v = sel.value;
      var rows = [].slice.call(grid.children);
      if (v === 'featured') {
        original.forEach(function (n) { grid.appendChild(n); });
        return;
      }
      rows.sort(function (a, b) {
        if (v === 'price-asc')  return (+a.dataset.price || 0) - (+b.dataset.price || 0);
        if (v === 'price-desc') return (+b.dataset.price || 0) - (+a.dataset.price || 0);
        if (v === 'name')       return String(a.dataset.name || '').localeCompare(String(b.dataset.name || ''));
        return 0;
      });
      rows.forEach(function (n) { grid.appendChild(n); });
    });
  })();

  /* --- Favourites · one SKU, every card in sync -------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-site-fav]');
    if (!b) return;
    var sku = b.dataset.siteFav;
    var on = b.getAttribute('aria-pressed') !== 'true';
    saved[sku] = on;
    if (!on) delete saved[sku];
    persistSaved();
    $$('[data-site-fav="' + sku + '"]').forEach(function (n) {
      n.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var out = $('[data-site-saved-count]');
    if (out) out.textContent = Object.keys(saved).length;
  });
  (function () {
    var out = $('[data-site-saved-count]');
    if (out) out.textContent = Object.keys(saved).length;
  })();

  (function () {
    var badges = $$('[data-cart-count], [data-site-saved-count]');
    if (!badges.length) return;
    function sync(n) { n.hidden = (n.textContent.trim() === '0' || n.textContent.trim() === ''); }
    badges.forEach(function (n) {
      sync(n);
      if ('MutationObserver' in window) {
        new MutationObserver(function () { sync(n); })
          .observe(n, { childList: true, characterData: true, subtree: true });
      }
    });
  })();

  /* Quick view — own dialog, own scrim, focus trapped */
  (function () {
    var qv = $('[data-site-qv]');
    var scrim = $('[data-site-scrim]');
    if (!qv || !scrim) return;
    var last = null, release = null;

    /* Quick view · real variants */
    var VCACHE = {};
    var qvState = { variants: [], names: [], chosen: [], handle: null };

    function qvRow(sel) { return $(sel, qv); }

    function qvMatch() {
      for (var i = 0; i < qvState.variants.length; i++) {
        var v = qvState.variants[i], ok = true;
        for (var j = 0; j < qvState.chosen.length; j++) {
          if (qvState.chosen[j] !== null && v.options[j] !== qvState.chosen[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function qvHint(msg) {
      var h = qvRow('[data-qv-hint]');
      if (!h) { return; }
      h.textContent = msg || '';
      h.hidden = !msg;
    }

    function qvPaint() {
      var v = qvMatch();
      var add = qvRow('[data-qv-add]');
      var H = window.LLVariantHint;
      if (H) {
        if (!v) { qvHint('That combination isn\'t sold. Choose another option.'); }
        else if (!v.available) { qvHint(H.soldOut(qvState.variants, v.options, qvState.names)); }
        else { qvHint(''); }
      }
      var priceBox = qvRow('[data-qv-price]');
      if (priceBox && v) {
        priceBox.innerHTML =
          '<span class="price price--lg">' + money(v.price / 100) + '</span>' +
          (v.compare_at_price && v.compare_at_price > v.price
            ? '<span class="product__was">' + money(v.compare_at_price / 100) + '</span>' : '');
      }
      var sku = qvRow('[data-qv-sku]');
      if (sku && v) sku.textContent = v.sku || '';
      if (add) {
        add.disabled = !v || !v.available;
        add.textContent = !v ? 'Unavailable' : (!v.available ? 'Sold out' : 'Add to cart');
        if (v) { add.setAttribute('data-qv-variant', v.id); } else { add.removeAttribute('data-qv-variant'); }
      }
    }

    function qvOptions() {

      var rows = [qvRow('[data-qv-counts]'), qvRow('[data-qv-sizes]')];

      [0, 1].forEach(function (n) {
        var g = qvRow('[data-qv-optgroup="' + n + '"]');
        if (g) g.hidden = !qvState.names[n];
      });
      qvState.names.forEach(function (name, idx) {
        var row = rows[idx] || rows[0];
        if (!row) return;
        var lbl = qvRow('[data-qv-optname="' + idx + '"]');
        if (lbl) lbl.textContent = name;
        var values = [];
        qvState.variants.forEach(function (v) {
          if (values.indexOf(v.options[idx]) === -1) values.push(v.options[idx]);
        });
        row.innerHTML = values.map(function (val) {
          /* Cross out values that can't be bought with the other choices. */
          var trial = qvState.chosen.slice(); trial[idx] = val;
          var hit = null;
          qvState.variants.forEach(function (v) {
            if (!hit && v.options.every(function (o, k) { return trial[k] == null || o === trial[k]; })) { hit = v; }
          });
          var avail = !hit ? ' data-avail="none"' : (!hit.available ? ' data-avail="sold"' : '');
          return '<button class="size-opt" type="button" data-qv-opt="' + idx + '" data-qv-val="' +
            esc(val) + '" aria-pressed="' + (val === qvState.chosen[idx] ? 'true' : 'false') + '"' + avail + '>' +
            esc(val) + '</button>';
        }).join('');
      });
    }

    function loadVariants(p) {
      var handle = p.handle;
      qvState.handle = handle;
      function apply(data) {
        if (qvState.handle !== handle) return;      /* a newer card won the race */
        qvState.variants = (data.variants || []).filter(function (v) { return v; });
        qvState.names = (data.options || []).map(function (o) { return o.name || o; });
        var first = qvState.variants.filter(function (v) { return v.available; })[0] || qvState.variants[0];
        qvState.chosen = first ? first.options.slice() : [];
        qvOptions();
        qvPaint();
      }
      if (VCACHE[handle]) { apply(VCACHE[handle]); return; }
      if (!window.fetch) return;
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { VCACHE[handle] = d; apply(d); })
        .catch(function () {});
    }

    /* Option clicks and the add itself, delegated so they survive the
       innerHTML rebuild above. */
    qv.addEventListener('click', function (e) {
      var opt = e.target.closest && e.target.closest('[data-qv-opt]');
      if (opt) {
        var idx = +opt.getAttribute('data-qv-opt');
        qvState.chosen[idx] = opt.getAttribute('data-qv-val');
        qvOptions();
        qvPaint();
        return;
      }
      var add = e.target.closest && e.target.closest('[data-qv-add]');
      if (!add) return;
      if (add.disabled) { qvPaint(); return; }
      var id = add.getAttribute('data-qv-variant');
      if (!id || !window.fetch) return;
      var qtyEl = $('[data-qv-qty] .stepper__value', qv);
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: +id, quantity: parseInt(qtyEl && qtyEl.value, 10) || 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:changed'));
          close();
          /* After close() restores focus, so the drawer owns it. */
          var open = document.querySelector('[data-open-cart]');
          if (open) setTimeout(function () { open.click(); }, 280);
        })
        .catch(function () {
          var link = $('[data-qv-link]', qv);
          if (link) window.location.href = link.getAttribute('href');
        })
        .then(function () { add.disabled = false; });
    });

    function fill(p) {
      var set = function (sel, html) { var n = $(sel, qv); if (n) n.innerHTML = html; };
      var unit = unitPrice(p);

      set('[data-qv-bed]',
        '<img src="' + esc(p.image) + '" alt="' + esc(p.alt) +
          '" width="900" height="900" decoding="async">');
      set('[data-qv-name]', esc(p.shortTitle));
      set('[data-qv-meta]', esc(p.brand) + ' · ' + (p.mil ? p.mil + ' mil · ' : '') + esc(p.material) +
        (p.colour ? ' · ' + esc(p.colour) : ''));
      set('[data-qv-stock]', stockMarkup(p));
      set('[data-qv-price]',
        '<span class="price price--lg">' + money(p.price) + '</span>' +
        (p.compareAtPrice ? '<span class="product__was">' + money(p.compareAtPrice) + '</span>' : '') +
        (p.savingsPct ? '<span class="product__save">Save ' + p.savingsPct + '%</span>' : '') +
        (unit ? '<span class="product__unit">' + unit + ' / glove</span>' : ''));

      set('[data-qv-sizes]', '');
      set('[data-qv-counts]', '');
      var sku = $('[data-qv-sku]', qv); if (sku) sku.textContent = p.sku;
      var add = $('[data-qv-add]', qv);
      if (add) { add.removeAttribute('data-add'); add.disabled = true; }
      loadVariants(p);
      var link = $('[data-qv-link]', qv);
      if (link) link.setAttribute('href', p.url);
      var qty = $('[data-qv-qty]', qv);
      if (qty) { delete qty.dataset.bound; var v = $('.stepper__value', qty); if (v) v.value = 1; bindStepper(qty); }
    }

    /* The catalogue may not be loaded on this page: fetch the one product. */
    function open(handle) {
      var p = byHandle(handle);
      if (p) { show(p); return; }
      fetch('/products/' + encodeURIComponent(handle) + '.json', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.product) { show(LL_map(d.product)); } else { location.href = '/products/' + handle; } })
        .catch(function () { location.href = '/products/' + handle; });
    }
    function show(p) {
      fill(p);
      last = document.activeElement;
      qv.hidden = false; scrim.hidden = false;
      requestAnimationFrame(function () {
        qv.classList.add('is-open');
        scrim.classList.add('is-open');
        var x = $('[data-qv-x]', qv); if (x) x.focus();
      });
      release = trap(qv);
      document.body.style.overflow = 'hidden';
    }
    function close() {
      qv.classList.remove('is-open');
      scrim.classList.remove('is-open');
      document.body.style.overflow = '';
      if (release) { release(); release = null; }
      setTimeout(function () {
        qv.hidden = true;
        if (!$('.mnav.is-open')) scrim.hidden = true;
        if (last) last.focus();
      }, 250);
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-site-quick]');
      if (b) { e.preventDefault(); open(b.dataset.siteQuick); return; }
      if (e.target.closest('[data-qv-x]')) close();
    });
    scrim.addEventListener('click', function () { if (qv.classList.contains('is-open')) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && qv.classList.contains('is-open')) close();
    });
  })();



  /* 11 · Comparison table — hide the scroll hint once it is used */
  (function () {
    var box = $('[data-compare-scroll]');
    var hint = $('[data-compare-hint]');
    if (!box || !hint) return;
    box.addEventListener('scroll', function () {
      hint.style.opacity = box.scrollLeft > 12 ? '0' : '1';
    }, { passive: true });
  })();

  /* Sticky mobile action bar — rises once the hero is passed */
  (function () {
    var bar = $('[data-site-bar]');
    var hero = $('#hero');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-up', !entries[0].isIntersecting);
    }, { rootMargin: '-40% 0px 0px 0px' }).observe(hero);
  })();


})();

/* R2 · CINEMATIC HERO ENGINE */
function LLCine() {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Re-running this (the editor re-renders a section on every settings
     change) must not stack a second set of scroll/resize handlers. */
  if (LLCine._ac) { LLCine._ac.abort(); }
  LLCine._ac = new AbortController();
  var _sig = LLCine._ac.signal;

  var stage = document.getElementById('hero');
  var cine = $('[data-cine]');
  if (!stage || !cine) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');


  var SLIDES = (function () {
    var node = document.querySelector('[data-cine-slides]');
    if (node) {
      try {
        var parsed = JSON.parse(node.textContent);
        if (parsed && parsed.length) {
          parsed.forEach(function (s) {
            if (!s.colours || !s.colours.length) { delete s.colours; }
          });
          return parsed;
        }
      } catch (e) {}
    }
    return [];
  })();

  var N = SLIDES.length;
  if (!N) return;
  var el = {
    bg: $('[data-cine-bg]'), glow: $('[data-cine-glow]'),
    eyebrow: $('[data-cine-eyebrow]'), title: $('[data-cine-title]'), sub: $('[data-cine-sub]'),
    cta: $('[data-cine-cta]'), ctat: $('[data-cine-ctat]'),
    shot: $('[data-cine-shot]'), ghost: $('[data-cine-ghost]'), nextimg: $('[data-cine-nextimg]'),
    bal: $('[data-cine-bal]'), bav: $('[data-cine-bav]'),
    bbl: $('[data-cine-bbl]'), bbv: $('[data-cine-bbv]'),
    tag: $('[data-cine-tag]'), colours: $('[data-cine-colours]'),
    index: $('[data-cine-index]'), name: $('[data-cine-name]'),
    pct: $('[data-cine-pct]'), fill: $('[data-cine-fill]'),
    head: $('[data-head-over]'), ann: $('[data-ann]')
  };
  var dots = $$('[data-cine-dot]');

  var cur = -1;

  (function () {
    var rest = SLIDES.slice(1);
    function warm() { rest.forEach(function (s) { var i = new Image(); i.src = s.img; }); }
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 });
    else window.addEventListener('load', function () { setTimeout(warm, 900); }, { signal: _sig });
  })();

  function paint(i, dir) {
    if (i === cur) return;
    var s = SLIDES[i];
    var prev = cur;
    cur = i;

    cine.style.setProperty('--tc-accent', s.accent);
    cine.style.setProperty('--tc-title', s.title_c);
    cine.style.setProperty('--tc-text', s.text_c);
    cine.style.setProperty('--tc-bg', s.bg);
    cine.style.setProperty('--tc-glow', s.glow);
    cine.classList.toggle('is-light', s.light);

    if (el.eyebrow) el.eyebrow.textContent = s.eyebrow;
    el.title.innerHTML = s.title;
    el.sub.textContent = s.sub;
    el.ctat.textContent = s.cta;
    el.cta.setAttribute('href', s.href);

    if (el.ghost && prev !== -1 && !reduced.matches) {
      el.ghost.src = SLIDES[prev].img;
      el.ghost.removeAttribute('data-go');
      void el.ghost.offsetWidth;
      el.ghost.setAttribute('data-go', dir < 0 ? 'back' : 'fwd');
    }
    el.shot.src = s.img;
    el.shot.alt = s.alt;

    cine.classList.toggle('has-recolour', !!s.recolour);
    el.nextimg.src = SLIDES[(i + 1) % N].img;
    el.nextimg.classList.toggle('is-recoloured', !!SLIDES[(i + 1) % N].recolour);
    el.bal.textContent = s.bal; el.bav.textContent = s.bav;
    el.bbl.textContent = s.bbl; el.bbv.textContent = s.bbv;
    el.index.textContent = String(i + 1).padStart(2, '0');
    el.name.textContent = s.name;

    if (el.tag) {
      el.tag.textContent = s.tag || '';
      el.tag.hidden = !s.tag;
    }

    if (el.colours) {
      el.colours.innerHTML = '';
      el.colours.hidden = !s.colours;
      if (s.colours) {
        s.colours.forEach(function (c) {
          var node = document.createElement(c.current ? 'span' : 'a');
          node.className = 'cine__swatch' + (c.current ? ' is-current' : '');
          if (!c.current) node.href = c.href;
          var dot = document.createElement('i');
          dot.style.background = c.hex;
          node.appendChild(dot);
          node.appendChild(document.createTextNode(c.name));
          if (c.current) node.setAttribute('aria-current', 'true');
          el.colours.appendChild(node);
        });
      }
    }

    dots.forEach(function (d, di) { d.setAttribute('aria-current', String(di === i)); });

    // The header wears the slide's theme while it rides over the hero.
    if (el.head) el.head.classList.toggle('is-onDark', !s.light);

    // Retrigger the entry animation by flipping the attribute.
    if (prev !== -1 && !reduced.matches) {
      cine.removeAttribute('data-anim');
      void cine.offsetWidth;
      cine.setAttribute('data-anim', dir < 0 ? 'back' : 'fwd');
    }
  }

  /* --- Scroll → slide + progress ---------------------------- */
  var ticking = false;

  function stageTop() {
    return stage.getBoundingClientRect().top + window.scrollY;
  }
  function travelPx() {
    return Math.max(1, stage.offsetHeight - window.innerHeight);
  }

  function read() {
    ticking = false;
    var rect = stage.getBoundingClientRect();
    var travel = travelPx();
    var p = Math.min(1, Math.max(0, -rect.top / travel));

    /* Equal segments per slide; a 15% dead band at each edge stops a
       boundary flicker from skipping a slide. */
    var f = p * N;
    var i = Math.min(N - 1, Math.floor(f));
    if (cur > -1 && Math.abs(i - cur) === 1 && Math.abs(f - (i > cur ? i : cur)) < 0.15) { i = cur; }
    paint(i, i > cur ? 1 : -1);

    el.fill.style.setProperty('--p', p.toFixed(4));
    el.pct.textContent = Math.round(p * 100) + '%';

    // Header goes solid halfway through the last slide, not before.
    if (el.ann) el.ann.classList.toggle('is-retracted', window.scrollY > 40);
    if (el.head) el.head.classList.toggle('is-landed', f >= N - 0.5);
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(read); }
  }

  window.addEventListener('scroll', onScroll, { passive: true, signal: _sig });
  window.addEventListener('resize', onScroll, { passive: true, signal: _sig });

  /* --- Jump to a slide --------------------------------------- */
  function goTo(i) {
    i = Math.max(0, Math.min(N - 1, i));
    if (reduced.matches) { paint(i, i > cur ? 1 : -1); return; }
    window.scrollTo({
      top: stageTop() + ((i + 0.5) / N) * travelPx(),
      behavior: 'smooth'
    });
  }

  dots.forEach(function (d) {
    d.addEventListener('click', function () { goTo(+d.dataset.cineDot); });
  });
  var next = $('[data-cine-next]');
  if (next) next.addEventListener('click', function () { goTo(cur + 1 >= N ? 0 : cur + 1); });

  // Arrow keys, but only while the hero actually owns the viewport.
  document.addEventListener('keydown', function (e) {
    var r = stage.getBoundingClientRect();
    if (r.top > 0 || r.bottom < window.innerHeight) return;
    if (document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); goTo(cur + 1); }
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); goTo(cur - 1); }
  }, { signal: _sig });

  function measureHead() {
    if (!el.head) return;
    document.documentElement.style.setProperty(
      '--head-real', Math.round(el.head.getBoundingClientRect().height) + 'px');
  }
  measureHead();
  window.addEventListener('resize', measureHead, { passive: true, signal: _sig });
  if ('ResizeObserver' in window && el.head) new ResizeObserver(measureHead).observe(el.head);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureHead);

  reduced.addEventListener('change', read, { signal: _sig });

  read();
}

/* The hero engine is re-entrant so the theme editor can rebuild the
   section without a page reload. */
LLCine();
document.addEventListener('shopify:section:load', function (e) {
  if (e.target && e.target.querySelector && e.target.querySelector('[data-cine]')) { LLCine(); }
});
document.addEventListener('shopify:section:unload', function (e) {
  if (e.target && e.target.querySelector && e.target.querySelector('[data-cine]') && LLCine._ac) {
    LLCine._ac.abort();
    LLCine._ac = null;
  }
});

/* R2 · COMPARE TRAY */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var picked = [];
  try { picked = JSON.parse(localStorage.getItem('ll-compare') || '[]'); } catch (e) { picked = []; }
  /* Entries are product handles; anything else is from an older version. */
  picked = picked.filter(function (h) { return /^[a-z0-9-]+$/.test(h); });

  var tray = $('[data-compare-tray]');
  var count = $('[data-compare-count]');

  function save() { try { localStorage.setItem('ll-compare', JSON.stringify(picked)); } catch (e) {} }

  function paint() {
    $$('[data-site-compare]').forEach(function (b) {
      b.setAttribute('aria-pressed', picked.indexOf(b.dataset.siteCompare) > -1 ? 'true' : 'false');
    });
    if (count) count.textContent = picked.length;
    if (tray) tray.classList.toggle('is-up', picked.length > 0);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-site-compare]');
    if (b) {
      e.preventDefault();
      var sku = b.dataset.siteCompare;
      var at = picked.indexOf(sku);
      if (at > -1) picked.splice(at, 1);
      else if (picked.length < 4) picked.push(sku);
      else return;                       // four is the table's width
      save();
      paint();
      return;
    }
    if (e.target.closest('[data-compare-clear]')) {
      picked = []; save(); paint(); closeCmp();
    }
    if (e.target.closest('[data-compare-open]')) { e.preventDefault(); openCmp(); }
    if (e.target.closest('[data-cmp-x]')) { closeCmp(); }
    var rm = e.target.closest('[data-cmp-remove]');
    if (rm) {
      var at2 = picked.indexOf(rm.getAttribute('data-cmp-remove'));
      if (at2 > -1) { picked.splice(at2, 1); save(); paint(); }
      if (picked.length) { openCmp(); } else { closeCmp(); }
    }
  });

  /* The comparison itself: live product data, side by side. */
  var cmp = $('[data-cmp]'), cmpBody = $('[data-cmp-body]'), scrim = $('[data-site-scrim]');
  var CACHE = {};
  var escH = function (v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var cash = function (n) { return '$' + Number(n || 0).toFixed(2); };

  function load(h) {
    if (CACHE[h]) { return Promise.resolve(CACHE[h]); }
    var url = '/products/' + encodeURIComponent(h);
    var json = function (u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }); };
    /* .json has the catalogue fields; .js is the one that knows availability. */
    return Promise.all([json(url + '.json'), json(url + '.js')])
      .then(function (r) {
        var p = r[0] && r[0].product ? LL_map(r[0].product) : null;
        if (p && r[1]) { p.inStock = !!r[1].available; }
        if (p) { CACHE[h] = p; }
        return p;
      })
      .catch(function () { return null; });
  }

  function table(list) {
    var rows = [
      ['Price', function (p) { return 'From ' + cash(p.price) + (p.savingsPct ? ' <span class="cmpx__save">Save ' + p.savingsPct + '%</span>' : ''); }],
      ['Thickness', function (p) { return p.mil ? p.mil + ' mil' : '—'; }],
      ['Material', function (p) { return escH(p.material || '—'); }],
      ['Color', function (p) { return escH(p.colour || '—'); }],
      ['Sizes', function (p) { return escH((p.sizes || []).join(', ') || '—'); }],
      ['Packs', function (p) { return escH((p.counts || []).join(', ') || '—'); }],
      ['Stock', function (p) { return p.inStock ? '<span class="dot dot--live"></span>In stock' : '<span class="dot"></span>Out of stock'; }]
    ];
    var head = list.map(function (p) {
      return '<th scope="col"><a class="cmpx__prod" href="' + escH(p.url) + '"><img src="' + escH(p.image) + '" alt="" width="120" height="120" loading="lazy">' +
        '<span>' + escH(p.shortTitle) + '</span></a>' +
        '<button class="cmpx__rm" type="button" data-cmp-remove="' + escH(p.handle) + '">Remove</button></th>';
    }).join('');
    var body = rows.map(function (r) {
      return '<tr><th scope="row">' + r[0] + '</th>' + list.map(function (p) { return '<td>' + r[1](p) + '</td>'; }).join('') + '</tr>';
    }).join('');
    var foot = '<tr><th scope="row"></th>' + list.map(function (p) {
      return '<td><a class="btn btn--primary btn--sm" href="' + escH(p.url) + '">View product</a></td>';
    }).join('') + '</tr>';
    return '<div class="cmpx__scroll"><table class="cmpx__table"><thead><tr><th></th>' + head + '</tr></thead><tbody>' + body + foot + '</tbody></table></div>';
  }

  function openCmp() {
    if (!cmp || !picked.length) { return; }
    cmpBody.innerHTML = '<p class="cmpx__loading">Loading…</p>';
    cmp.hidden = false; if (scrim) { scrim.hidden = false; }
    requestAnimationFrame(function () { cmp.classList.add('is-open'); if (scrim) { scrim.classList.add('is-open'); } });
    document.body.style.overflow = 'hidden';
    Promise.all(picked.map(load)).then(function (list) {
      list = list.filter(Boolean);
      cmpBody.innerHTML = list.length ? table(list) : '<p class="cmpx__loading">Those products are no longer available.</p>';
      var x = $('[data-cmp-x]'); if (x) { x.focus(); }
    });
  }
  function closeCmp() {
    if (!cmp || cmp.hidden) { return; }
    cmp.classList.remove('is-open'); if (scrim) { scrim.classList.remove('is-open'); }
    document.body.style.overflow = '';
    setTimeout(function () { cmp.hidden = true; if (scrim && !document.querySelector('.is-open[data-site-qv], .mnav.is-open')) { scrim.hidden = true; } }, 250);
  }
  if (scrim) { scrim.addEventListener('click', closeCmp); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCmp(); } });

  paint();
})();

/* R6 · GLOVE FINDER */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var gf = $('[data-gf]');
  if (!gf) return;
  var CAT = window.LL_CATALOGUE || [];

  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  }); };

  var STEPS_FALLBACK = [
    { q: 'What are you buying for?', slot: 'Industry', type: 'icon',
      opts: [
        { v: 'Medical',      icon: 'ic-cross' },
        { v: 'Automotive',   icon: 'ic-wrench' },
        { v: 'Food service', icon: 'ic-food' },
        { v: 'Industrial',   icon: 'ic-gear' },
        { v: 'Laboratory',   icon: 'ic-flask' },
        { v: 'Cleaning',     icon: 'ic-spray' },
        { v: 'Beauty',       icon: 'ic-scissors' }
      ] },
    { q: 'How much protection?', slot: 'Protection', type: 'pill',
      opts: [

        { v: 'Light duty' },
        { v: 'Standard'   },
        { v: 'Heavy duty' },
        { v: 'Maximum'    }
      ] },

    { q: 'Any color preference?', slot: 'Color', type: 'swatch',
      opts: [
        { v: 'Black',          hex: '#23262A' },
        { v: 'Blue',           hex: '#4E91EC' },
        { v: 'Clear',          hex: '#DCE4EA' },
        { v: 'Bright colors',  hex: 'linear-gradient(135deg,#A2CE53 0%,#EF6F1E 50%,#E86A9A 100%)' },
        { v: 'No preference',  hex: null }
      ] },
    { q: 'How often will you use them?', slot: 'Frequency', type: 'pill',
      opts: [
        { v: 'Daily' }, { v: 'Weekly' }, { v: 'Occasionally' }
      ] }
  ];

  var STEPS = (window.LL_FINDER_STEPS && window.LL_FINDER_STEPS.length)
    ? window.LL_FINDER_STEPS
    : STEPS_FALLBACK;

  // The scoring below reads plain strings, so give it plain strings.
  function optValues(step) { return step.opts.map(function (o) { return o.v; }); }

  var COLOUR_MATCH = {
    'black': ['black'],
    'blue': ['blue'],
    'clear': ['clear', 'white'],
    'bright colors': ['pink', 'purple', 'green', 'orange'],
    'bright colours': ['pink', 'purple', 'green', 'orange']
  };
  var MIL_BAND = { 'light duty': [0, 4], 'standard': [4, 5], 'heavy duty': [6, 6], 'maximum': [7, 99] };
  var INDUSTRY = {
    'medical':      { re: /medical|exam|dental|clinical|patient|first responder/, ok: function (p) { return p.material === 'nitrile' && (p.mil || 0) <= 5; } },
    'automotive':   { re: /automotive|mechanic|industrial|heavy duty|grip/,       ok: function (p) { return (p.mil || 0) >= 6 || p.colour === 'black'; } },
    'food service': { re: /food|kitchen/,                                         ok: function (p) { return p.material === 'vinyl' || p.colour === 'blue'; } },
    'industrial':   { re: /industrial|heavy duty|work glove|grip/,                ok: function (p) { return (p.mil || 0) >= 6; } },
    'laboratory':   { re: /lab|research|testing|long cuff/,                       ok: function (p) { return p.material === 'nitrile' && (p.mil || 0) <= 5; } },
    'cleaning':     { re: /household|home and garden|cleaning|janitorial/,        ok: function (p) { return p.material === 'vinyl' || (p.mil || 0) >= 5; } },
    'beauty':       { re: /salon|tattoo|beauty|cosmetic/,                         ok: function (p) { return p.material === 'nitrile' && /black|pink|purple/.test(p.colour); } }
  };

  var at = 0, answers = [], note = '';
  var opts = $('[data-gf-opts]', gf), q = $('[data-gf-q]', gf), count = $('[data-gf-count]', gf),
      back = $('[data-gf-back]', gf), result = $('[data-gf-result]', gf);

  /* Answers by step slot, so reordering steps in the editor cannot misread them. */
  function answer(slot) {
    for (var i = 0; i < STEPS.length; i++) {
      if (String(STEPS[i].slot || '').toLowerCase() === slot) { return String(answers[i] || '').toLowerCase(); }
    }
    return '';
  }

  function resolve() {
    var band = MIL_BAND[answer('protection')];
    var cols = COLOUR_MATCH[answer('color') || answer('colour')];
    var ind = INDUSTRY[answer('industry')];
    var freq = answer('frequency');

    function milOf(p) { return p.mil || (p.material === 'vinyl' ? 3 : null); }
    var fitsBand = function (p) { var m = milOf(p); return !band || (m !== null && m >= band[0] && m <= band[1]); };
    var fitsCol = function (p) { return !cols || cols.some(function (c) { return (p.colour || '').indexOf(c) !== -1; }); };

    var pool = CAT.filter(function (p) { return p.inStock; });
    var both = pool.filter(function (p) { return fitsBand(p) && fitsCol(p); });
    note = '';
    if (!both.length) {
      both = pool.filter(fitsCol);
      note = both.length ? 'Nothing in that color at that thickness, so these are the nearest thicknesses.' : '';
    }
    if (!both.length) {
      both = pool.filter(fitsBand);
      note = 'Nothing in that color at that thickness, so these are the closest gloves at that thickness.';
    }
    if (!both.length) { both = pool; }

    var mid = band ? (band[0] + Math.min(band[1], 9)) / 2 : 5;
    var scored = both.map(function (p) {
      var score = 0, m = milOf(p);
      if (ind) {
        if (ind.re.test(p.hay || '')) score += 30;
        if (ind.ok(p)) score += 20;
      }
      if (m !== null) score -= Math.abs(m - mid) * 4;
      if (freq === 'daily' && p.material === 'nitrile') score += 4;
      if (freq === 'occasionally' && p.material === 'vinyl') score += 4;
      if (p.savingsPct) score += 1;
      return { p: p, score: score };
    });
    scored.sort(function (a, b) { return b.score - a.score; });
    return scored.slice(0, 3).map(function (x) { return x.p; });
  }

  var intro  = $('[data-gf-intro]', gf);
  var stage  = $('[data-gf-stage]', gf);
  var chips  = $('[data-gf-chips]', gf);
  var start  = $('[data-gf-start]', gf);

  function show(which) {
    if (intro) intro.hidden = which !== 'intro';
    if (stage) stage.hidden = which === 'intro';
  }

  function paintChips() {
    if (!chips) return;
    chips.innerHTML = answers.map(function (a, i) {
      return '<button class="quiz__chip" type="button" data-gf-jump="' + i + '">' +
             esc(a) + '</button>';
    }).join('');
    chips.hidden = answers.length === 0;
  }

  function brandLabel(p) {
    if (p.mil === 8 || /gripxx/i.test((p.handle || '') + ' ' + (p.title || ''))) return 'GRIPXX';
    return 'LONDON LABS';
  }

  /* Wait on the catalogue: the last question must never score an empty array. */
  function renderResults() {
    q.textContent = 'Matching the catalogue\u2026';
    opts.innerHTML = '';
    result.setAttribute('data-on', 'true');

    LL_catalogue(function (cat) {
      var picks = resolve();
      q.textContent = picks.length === 1
        ? 'Your closest match'
        : 'Your ' + picks.length + ' closest matches';
      count.textContent = note || ('Matched from ' + cat.length + ' live products');
      result.innerHTML = picks.map(function (p, i) {
        return '' +
          '<a class="gfr" href="' + esc(p.url) + '">' +
            '<span class="gfr__bed"><img src="' + esc(p.image) + '" alt="" width="72" height="72" loading="lazy" decoding="async"></span>' +
            '<span class="gfr__body">' +
              (i === 0 ? '<span class="gfr__flag">Closest match</span>' : '') +
              '<b class="gfr__name">' + esc(p.shortTitle) + '</b>' +
              '<span class="gfr__meta">' + brandLabel(p) + (p.mil ? ' · ' + p.mil + ' mil' : '') +
                ' · ' + esc(p.material) + (p.colour ? ' · ' + esc(p.colour) : '') + '</span>' +
            '</span>' +
            '<span class="gfr__go"><svg width="18" height="18" aria-hidden="true"><use href="#ic-arrow"></use></svg></span>' +
          '</a>';
      }).join('') +
      '<p class="gfr__foot">Every London Labs glove is FDA cleared, ASTM certified and latex free. ' +
      '<button class="quiz__restart" type="button" data-gf-restart>Start again</button></p>';
      paintChips();
      /* render()'s focus line never runs on this branch, and the button
         that was just activated has been wiped from the DOM. */
      if (started) { q.setAttribute('tabindex', '-1'); q.focus({ preventScroll: true }); }
    });
  }

  function render() {
    if (at >= STEPS.length) { renderResults(); return; }

    result.setAttribute('data-on', 'false');
    var st = STEPS[at];
    q.textContent = st.q;
    opts.className = 'quiz__opts quiz__opts--' + st.type;
    opts.innerHTML = st.opts.map(function (o) {
      var on = answers[at] === o.v ? 'true' : 'false';
      if (st.type === 'icon') {
        return '<button class="quiz__tile" type="button" aria-pressed="' + on + '">' +
                 '<span class="quiz__ring"><svg width="30" height="30" aria-hidden="true"><use href="#' + o.icon + '"></use></svg></span>' +
                 '<span class="quiz__tileLab">' + esc(o.v) + '</span>' +
               '</button>';
      }
      if (st.type === 'swatch') {
        var fill = o.hex ? ' style="background:' + o.hex + '"' : '';
        return '<button class="quiz__tile" type="button" aria-pressed="' + on + '">' +
                 '<span class="quiz__ring quiz__ring--sw' + (o.hex ? '' : ' quiz__ring--any') + '"' + fill + '>' +
                   (o.hex ? '' : '<svg width="26" height="26" aria-hidden="true"><use href="#ic-check"></use></svg>') +
                 '</span>' +
                 '<span class="quiz__tileLab">' + esc(o.v) + '</span>' +
               '</button>';
      }
      return '<button class="quiz__opt" type="button" aria-pressed="' + on + '">' +
               esc(o.v) + (o.note ? '<i>' + esc(o.note) + '</i>' : '') +
             '</button>';
    }).join('');
    count.textContent = 'Question ' + (at + 1) + ' of ' + STEPS.length;
    back.hidden = at === 0;
    paintChips();

    /* Move focus to the new question so a keyboard or screen-reader user
       is not left on a button that has just been replaced. */
    if (started) q.setAttribute('tabindex', '-1'), q.focus({ preventScroll: true });
  }

  var started = false;

  if (start) {
    start.addEventListener('click', function () {
      started = true;
      show('quiz');
      render();
      /* Fetch while they answer. */
      LL_catalogue();
      stage.scrollIntoView({ block: 'center', behavior: reducedMotionOK() ? 'auto' : 'smooth' });
    });
  }

  function reducedMotionOK() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  opts.addEventListener('click', function (e) {
    var b = e.target.closest('.quiz__opt, .quiz__tile');
    if (!b) return;
    /* Tiles carry a label element; pills may carry a <i> note that is not
       part of the answer. Read the value, never the rendered text. */
    var lab = b.querySelector('.quiz__tileLab');
    var val = lab ? lab.textContent.trim() : b.firstChild.textContent.trim();
    answers[at] = val;
    at++;
    render();
  });

  back.addEventListener('click', function () {
    if (at > 0) { at--; answers.length = at; render(); }
    else { show('intro'); started = false; }
  });

  /* Chips and "start again" both rewind rather than reload. */
  gf.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-gf-jump]');
    if (jump) {
      at = +jump.dataset.gfJump;
      answers.length = at;
      render();
      return;
    }
    if (e.target.closest('[data-gf-restart]')) {
      at = 0; answers.length = 0; started = true;
      render();
      stage.scrollIntoView({ block: 'center', behavior: reducedMotionOK() ? 'auto' : 'smooth' });
    }
  });

  show('intro');
  render();
})();

/* R6 · GRIPXX ISLAND — same engine as the hero */
(function () {
  'use strict';
  var stage = document.querySelector('[data-gx]');
  if (!stage) return;
  var steps = Array.prototype.slice.call(stage.querySelectorAll('[data-gx-step]'));
  var fill = stage.querySelector('[data-gx-fill]');
  var pct = stage.querySelector('[data-gx-pct]');
  var N = steps.length, cur = -1, ticking = false;

  function read() {
    ticking = false;
    var rect = stage.getBoundingClientRect();
    var travel = Math.max(1, stage.offsetHeight - window.innerHeight);
    var p = Math.min(1, Math.max(0, -rect.top / travel));
    var i = Math.min(N - 1, Math.floor(p * N));
    if (i !== cur) {
      cur = i;
      steps.forEach(function (s, k) { s.setAttribute('data-on', String(k === i)); });
    }
    if (fill) fill.style.setProperty('--p', p.toFixed(4));
    if (pct) pct.textContent = Math.round(p * 100) + '%';
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(read); }
  }, { passive: true });
  window.addEventListener('resize', read, { passive: true });
  read();
})();

/* COLLECTION — facets, chips, count, sort */
(function () {
  var grid = document.querySelector('[data-cat-grid]');
  if (!grid) return;

  var $$c = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  var cards = $$c('.pcard', grid);
  var boxes = $$c('[data-facet]');
  var chips = document.querySelector('[data-facet-chips]');
  var count = document.querySelector('[data-cat-count]');
  var empty = document.querySelector('[data-cat-empty]');
  /* Two of these: the rail's "Clear all" and the one inside the empty
     state, so a dead end always carries its own way out. */
  var clears = $$c('[data-facet-clear]');
  var sort = document.querySelector('[data-cat-sort]');
  var total = cards.length;

  /* The order the build wrote, kept so "Featured" is a real option and
     not just "whatever you sorted by last". */
  var featured = cards.slice();

  function labelOf(b) {
    var span = b.parentNode && b.parentNode.querySelector('span');
    var text = span ? span.textContent.trim() : b.value;
    return b.dataset.facet === 'mil' ? text + ' mil' : text;
  }

  function active() {
    var by = {};
    boxes.forEach(function (b) {
      if (!b.checked) return;
      (by[b.dataset.facet] = by[b.dataset.facet] || []).push(b.value);
    });
    return by;
  }

  var MULTI = { size: 1, count: 1 };

  function matches(card, by) {
    return Object.keys(by).every(function (key) {
      var want = by[key];
      if (MULTI[key]) {
        var has = (card.dataset[key] || '').split(',');
        return want.some(function (v) { return has.indexOf(v) > -1; });
      }
      return want.indexOf(card.dataset[key] || '') > -1;
    });
  }

  function reorder() {
    var mode = sort ? sort.value : 'featured';
    var list = featured.slice();
    if (mode === 'price-asc') list.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
    if (mode === 'price-desc') list.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
    if (mode === 'name') list.sort(function (a, b) { return a.dataset.name.localeCompare(b.dataset.name); });
    list.forEach(function (c) { grid.appendChild(c); });
  }

  function render() {
    var by = active();
    var keys = Object.keys(by);
    var shown = 0;

    cards.forEach(function (c) {
      var ok = matches(c, by);
      c.hidden = !ok;
      if (ok) shown++;
    });

    /* Sort is re-applied on every pass so the two are additive: change a
       filter and the surviving cards stay in the chosen order. */
    reorder();

    if (count) count.innerHTML = 'Showing <b>' + shown + '</b> of <b>' + total + '</b> products';
    if (empty) empty.hidden = shown !== 0;
    clears.forEach(function (b) {
      /* The rail's control is pointless with nothing applied; the one in
         the empty state is inside a block that is itself hidden. */
      if (b.closest('[data-cat-empty]')) return;
      b.hidden = keys.length === 0;
    });

    /* Applied filters are echoed above the results, never left implicit
       in a panel the reader has to reopen to understand the result set. */
    if (chips) {
      chips.innerHTML = '';
      boxes.filter(function (b) { return b.checked; }).forEach(function (b) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'chip-filter chip-filter--applied';
        chip.textContent = labelOf(b) + ' ';
        chip.insertAdjacentHTML('beforeend', '<svg width="14" height="14" aria-hidden="true"><use href="#ic-x"></use></svg>');
        chip.setAttribute('aria-label', 'Remove filter ' + labelOf(b));
        chip.addEventListener('click', function () { b.checked = false; render(); });
        chips.appendChild(chip);
      });
      chips.hidden = keys.length === 0;
    }
  }

  function clearAll() {
    boxes.forEach(function (b) { b.checked = false; });
    render();
  }

  boxes.forEach(function (b) { b.addEventListener('change', render); });
  clears.forEach(function (b) { b.addEventListener('click', clearAll); });
  if (sort) sort.addEventListener('change', render);

  (function () {
    var q = new URLSearchParams(location.search);
    [['m', 'material'], ['mil', 'mil'], ['c', 'material'], ['b', 'brand'],
     ['size', 'size'], ['p', 'count']]
      .forEach(function (pair) {
        var want = q.get(pair[0]);
        if (!want) return;
        boxes.forEach(function (b) {
          if (b.dataset.facet === pair[1] && b.value.toLowerCase() === want.toLowerCase()) b.checked = true;
        });
      });
  })();

  render();
})();


(function () {
  var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-cutoff]'));
  if (!nodes.length) return;

  /* The warehouse is in Miami: the 5pm cut-off is Eastern time (DST-aware),
     whatever the shopper's own clock says. */
  var CUTOFF = 17 * 60;
  var fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
  });

  function miamiNow() {
    var p = {};
    fmt.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { weekend: p.weekday === 'Sat' || p.weekday === 'Sun', mins: (+p.hour) * 60 + (+p.minute) };
  }

  function render() {
    var now = miamiNow();
    var left = CUTOFF - now.mins;
    var sameDay = !now.weekend && left > 0;

    nodes.forEach(function (n) {
      var out = n.querySelector('[data-cutoff-text]') || n;
      n.removeAttribute('data-cutoff-soon');
      if (!sameDay) {
        out.textContent = 'Ships the next business day';
        return;
      }
      if (left <= 120) {
        var h = Math.floor(left / 60), m = left % 60;
        out.textContent = 'Ships today if you order within ' + (h ? h + 'h ' + m + 'm' : m + ' min');
        n.setAttribute('data-cutoff-soon', '');
        return;
      }
      out.textContent = 'Order before 5pm ET and it ships today';
    });
  }

  render();
  setInterval(render, 30000);
})();

(function () {
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-enter]'));
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('is-entered'); });
    return;
  }
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      els.forEach(function (el) { el.classList.add('is-entered'); });
    });
  });
  // Belt and braces: if anything above throws or a frame never lands,
  // the content is still visible well inside a second.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('is-entered'); });
  }, 900);
})();

/* SHOP BY INDUSTRY · flip deck. Circular: the active card always has
   neighbours on both sides, and wrapping never sweeps a card across. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var VISIBLE = 2;   // cards painted on each side of the active one

  [].forEach.call(document.querySelectorAll('[data-iflip]'), function (root) {
    var deck = root.querySelector('[data-iflip-deck]');
    if (!deck) return;
    var cards = [].slice.call(deck.querySelectorAll('[data-iflip-card]'));
    var N = cards.length;
    if (!N) return;

    var scope = root.closest('section') || root;
    var dotsHost = scope.querySelector('[data-iflip-dots]');
    var prev = scope.querySelector('[data-iflip-prev]');
    var next = scope.querySelector('[data-iflip-next]');
    var at = Math.floor(N / 2);
    var last = cards.map(function () { return null; });

    var dots = [];
    if (dotsHost) {
      cards.forEach(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'iflip__dot';
        var label = c.querySelector('.iflip__name');
        b.setAttribute('aria-label', label ? label.textContent.trim() : 'Industry ' + (i + 1));
        b.addEventListener('click', function () { go(i); });
        dotsHost.appendChild(b);
        dots.push(b);
      });
    }

    /* Shortest signed distance round the ring. */
    function offset(i) {
      var o = ((i - at) % N + N) % N;
      return o > N / 2 ? o - N : o;
    }

    function render() {
      var jumped = [];
      cards.forEach(function (c, i) {
        var o = offset(i), ao = Math.abs(o);
        // Crossing the back of the ring: move without animating.
        if (last[i] !== null && Math.abs(o - last[i]) > 1) { c.classList.add('is-jump'); jumped.push(c); }
        last[i] = o;
        c.style.setProperty('--o', o);
        c.style.setProperty('--ao', ao);
        var far = ao > VISIBLE;
        c.dataset.far = far ? 'true' : 'false';
        c.dataset.active = o === 0 ? 'true' : 'false';
        if (far && !reduced.matches) { c.setAttribute('aria-hidden', 'true'); c.setAttribute('tabindex', '-1'); }
        else { c.removeAttribute('aria-hidden'); c.removeAttribute('tabindex'); }
      });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === at)); });
      if (jumped.length) {
        void deck.offsetWidth;
        requestAnimationFrame(function () { jumped.forEach(function (c) { c.classList.remove('is-jump'); }); });
      }
    }

    function go(i) { at = ((i % N) + N) % N; render(); }

    if (prev) prev.addEventListener('click', function () { go(at - 1); });
    if (next) next.addEventListener('click', function () { go(at + 1); });

    /* Swipe. touch-action: pan-y on the deck keeps vertical scrolling. */
    var x0 = null, y0 = 0, swiped = false;
    deck.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      x0 = e.clientX; y0 = e.clientY; swiped = false;
    });
    deck.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; go(at + (dx < 0 ? 1 : -1)); }
    });
    deck.addEventListener('pointercancel', function () { x0 = null; });

    cards.forEach(function (c, i) {
      c.addEventListener('click', function (e) {
        if (swiped) { e.preventDefault(); swiped = false; return; }
        if (i !== at) { e.preventDefault(); go(i); }
      });
      c.addEventListener('focus', function () { if (i !== at) go(i); });
      c.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    deck.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(at - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(at + 1); }
    });

    /* Lazy images on the hidden cards would only start loading as they
       rotate in; fetch them all once the deck is near the viewport. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        deck.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      }, { rootMargin: '600px 0px' });
      io.observe(deck);
    }

    if (reduced.addEventListener) reduced.addEventListener('change', render);
    render();
  });
})();

(function () {
  if (!document.documentElement.classList.contains('js')) return;
  var idle = 0;

  function sweep() {
    // Re-query rather than caching a list at load. A cached list cannot see
    // anything rendered later, which also made the net impossible to test.
    var pending = document.querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (!pending.length) {
      // Stand down only after the page has been settled for a while, so a
      // later-rendered block is still covered.
      if (++idle >= 5 && timer) { clearInterval(timer); timer = null; }
      return;
    }
    idle = 0;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    Array.prototype.forEach.call(pending, function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add('is-revealed');  // on screen, still hidden
    });
  }

  var timer = setInterval(sweep, 1200);
  window.addEventListener('pageshow', sweep);
  setTimeout(sweep, 400);
})();

/* ROUND 3 · THE ABOUT PAGE COUNTERS */
(function () {
  'use strict';
  var band = document.querySelector('[data-countup]');
  if (!band) return;

  var figures = Array.prototype.slice.call(band.querySelectorAll('[data-count]'));
  if (!figures.length) return;

  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (still || typeof IntersectionObserver !== 'function') return;   // final values already rendered

  function run(el) {
    var to = parseInt(el.getAttribute('data-count'), 10);
    if (!(to > 0)) return;

    function land() { el.textContent = String(to); }

    if (document.hidden) { land(); return; }

    var start = null;
    var ms = 1100;
    var done = false;
    el.textContent = '0';

    /* The safety net. Fires whether or not the loop below ever ran. */
    var net = setTimeout(function () { if (!done) { done = true; land(); } }, ms + 500);

    function frame(t) {
      if (done) return;
      if (start === null) start = t;
      var p = Math.min((t - start) / ms, 1);
      /* Ease out cubic — the figure should arrive, not coast. */
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(to * eased));
      if (p < 1) { requestAnimationFrame(frame); return; }
      done = true;
      clearTimeout(net);
      land();                                 // land exactly on the real value
    }
    requestAnimationFrame(frame);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.disconnect();
      figures.forEach(run);
    });
  }, { threshold: 0.35 });

  io.observe(band);
})();

/* ROUND 3 · TESTIMONIALS — the active card */
(function () {
  'use strict';

  var marq = document.querySelector('[data-rmarq]');
  if (!marq) { return; }

  var stage = marq.closest('.rstage') || marq;
  var cards = Array.prototype.slice.call(marq.querySelectorAll('.tcard'));
  if (cards.length < 2) { return; }

  /* Under reduced motion the run does not move, so a focus card
     that never changes is just a card that looks odd. Skip. */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }

  var current = null;
  var running = false;
  var frame = 0;

  function tick() {
    if (!running) { return; }

    /* Every fourth frame is plenty for a 52-second traverse and
       keeps the measuring cost off the critical path. */
    if (frame++ % 4 === 0) {
      var mid = stage.getBoundingClientRect();
      var centre = mid.left + mid.width / 2;

      var best = null;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        /* Measure the card's UNSCALED centre, or the winner would
           drag itself sideways as it grows and oscillate. */
        var d = Math.abs(r.left + r.width / 2 - centre);
        if (d < bestDist) { bestDist = d; best = cards[i]; }
      }

      if (best !== current) {
        if (current) { current.classList.remove('is-focus'); }
        if (best) { best.classList.add('is-focus'); }
        current = best;
      }
    }

    requestAnimationFrame(tick);
  }

  function start() {
    if (running) { return; }
    running = true;
    requestAnimationFrame(tick);
  }
  function stop() {
    running = false;
    if (current) { current.classList.remove('is-focus'); current = null; }
  }

  if (typeof IntersectionObserver === 'function') {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
    }, { threshold: 0.15 }).observe(stage);
  } else {
    start();
  }
}());

/* PRODUCT DETAIL · one set of panels, two presentations */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdptabs]');
  if (!root) { return; }

  var bar    = root.querySelector('[data-pdptabs-bar]');
  var tabs   = Array.prototype.slice.call(root.querySelectorAll('[data-pdptab]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pdppanel]'));
  var accs   = Array.prototype.slice.call(root.querySelectorAll('[data-pdpacc]'));
  if (!tabs.length || !panels.length) { return; }

  var mq = window.matchMedia('(max-width: 860px)');
  var mode = null;
  var active = tabs[0].dataset.pdptab;

  function panelOf(key) {
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].dataset.pdppanel === key) { return panels[i]; }
    }
    return null;
  }

  /* --- tabs --------------------------------------------------- */
  function selectTab(key, focus) {
    active = key;
    tabs.forEach(function (t) {
      var on = t.dataset.pdptab === key;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) { t.focus(); }
    });
    panels.forEach(function (p) { p.hidden = p.dataset.pdppanel !== key; });
  }

  /* --- accordions --------------------------------------------- */
  function toggleAcc(key) {
    var btn = null;
    accs.forEach(function (a) { if (a.dataset.pdpacc === key) { btn = a; } });
    if (!btn) { return; }
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    var body = document.getElementById(btn.getAttribute('aria-controls'));
    if (body) { body.hidden = open; }
  }

  function apply(next) {
    if (next === mode) { return; }
    mode = next;
    root.setAttribute('data-pdpmode', mode);

    if (mode === 'tabs') {
      bar.hidden = false;
      accs.forEach(function (a) {
        a.parentNode.hidden = true;                 // the <h2> wrapper
        var body = document.getElementById(a.getAttribute('aria-controls'));
        if (body) { body.hidden = false; }          // the tab controls visibility now
      });
      selectTab(active, false);
    } else {
      bar.hidden = true;
      /* Every panel is present in accordion mode; only its BODY opens
         and closes, so the headers always form a complete list. */
      panels.forEach(function (p) { p.hidden = false; });
      accs.forEach(function (a) {
        a.parentNode.hidden = false;
        var open = a.dataset.pdpacc === active;
        a.setAttribute('aria-expanded', open ? 'true' : 'false');
        var body = document.getElementById(a.getAttribute('aria-controls'));
        if (body) { body.hidden = !open; }
      });
    }
  }

  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { selectTab(t.dataset.pdptab, false); });
    t.addEventListener('keydown', function (e) {
      var step = e.key === 'ArrowRight' ? 1
               : e.key === 'ArrowLeft' ? -1
               : e.key === 'Home' ? -i
               : e.key === 'End' ? tabs.length - 1 - i
               : 0;
      if (!step) { return; }
      e.preventDefault();
      selectTab(tabs[(i + step + tabs.length) % tabs.length].dataset.pdptab, true);
    });
  });

  accs.forEach(function (a) {
    a.addEventListener('click', function () { toggleAcc(a.dataset.pdpacc); });
  });

  apply(mq.matches ? 'accordion' : 'tabs');
  (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(
    function () { apply(mq.matches ? 'accordion' : 'tabs'); });
}());

/* COLLECTION · the filter sheet and the facet disclosures */
(function () {
  'use strict';

  var cat = document.querySelector('.cat');
  if (!cat) { return; }

  var sheet = cat.querySelector('[data-filter-sheet]');
  var open  = cat.querySelector('[data-filter-open]');
  if (!sheet || !open) { return; }

  var closers = Array.prototype.slice.call(cat.querySelectorAll('[data-filter-close]'));
  var count   = cat.querySelector('[data-filter-count]');
  var lastFocus = null;

  function setOpen(on) {
    if (on) { cat.setAttribute('data-filters-open', ''); }
    else    { cat.removeAttribute('data-filters-open'); }
    open.setAttribute('aria-expanded', on ? 'true' : 'false');
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (on) {
      lastFocus = document.activeElement;
      var x = sheet.querySelector('[data-filter-close]');
      if (x) { x.focus(); }
    } else {

      var back = (lastFocus && lastFocus.focus && lastFocus !== document.body) ? lastFocus : open;
      back.focus();
      lastFocus = null;
    }
  }

  open.addEventListener('click', function () { setOpen(true); });
  closers.forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cat.hasAttribute('data-filters-open')) { setOpen(false); }
  });

  /* How many filters are on, shown on the trigger. */
  function paintCount() {
    if (!count) { return; }
    var n = cat.querySelectorAll('[data-facet]:checked').length;
    count.textContent = String(n);
    count.hidden = n === 0;
  }
  cat.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-facet]')) { paintCount(); }
  });
  cat.addEventListener('click', function (e) {
    if (e.target && e.target.closest('[data-facet-clear]')) { setTimeout(paintCount, 0); }
  });
  paintCount();

  /* --- Facet disclosures ------------------------------------- */
  Array.prototype.slice.call(cat.querySelectorAll('.facet__toggle')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var on = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', on ? 'false' : 'true');
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      if (body) { body.hidden = on; }
    });
  });
}());

/* INDUSTRY DEEP LINKS · legacy ?i= redirect */
(function () {
  'use strict';
  if (!/\/pages\/industries$/.test(location.pathname)) { return; }

  var m = /[?&]i=([a-z-]+)/.exec(location.search);
  var want = m ? m[1] : (location.hash || '').replace(/^#/, '');
  if (!want) { return; }

  var target = document.getElementById(want);
  if (!target) { return; }

  history.replaceState(null, '', location.pathname + '#' + want);
  /* Wait a frame so layout has settled before measuring the offset. */
  requestAnimationFrame(function () {
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
  });
}());

/* COMPARE TABLE · scroll hint */
(function () {
  'use strict';

  function sync(box) {
    var wrap = box.closest ? box.closest('.compare') : null;
    if (!wrap) { return; }
    wrap.classList.toggle('is-scrollable', box.scrollWidth > box.clientWidth + 1);
    /* Drives the shadow on the sticky product column, so the cut edge
       only appears once there is actually something scrolled under it. */
    wrap.classList.toggle('is-scrolled', box.scrollLeft > 0);
  }

  function bind(root) {
    var boxes = (root || document).querySelectorAll('.compare__scroll');
    [].forEach.call(boxes, function (box) {
      sync(box);
      /* Content can arrive after first paint — a product image loading
         widens a column — so watch the box rather than measuring once. */
      if (window.ResizeObserver) {
        new ResizeObserver(function () { sync(box); }).observe(box);
      }
      if (!box.dataset.cmpBound) {
        box.dataset.cmpBound = '1';
        box.addEventListener('scroll', function () { sync(box); }, { passive: true });
      }
    });
    return boxes.length;
  }

  bind(document);
  window.addEventListener('resize', function () { bind(document); }, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
}());

(function () {
  'use strict';

  var form = document.querySelector('#pdp-form');
  if (!form) { return; }

  function readJSON(sel) {
    var el = document.querySelector(sel);
    try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
  }
  var VARIANTS = readJSON('[data-pdp-variants]');
  var MEDIA = readJSON('[data-pdp-media]');
  if (!VARIANTS.length) { return; }

  var $ = function (s) { return document.querySelector(s); };
  var select = form.querySelector('[data-pdp-variant]');
  var groups = [].slice.call(form.querySelectorAll('[role="group"]'));
  var priceEl = $('[data-pdp-price]'), wasEl = $('[data-pdp-was]');
  var saveEl = $('[data-pdp-save]'), stockEl = $('[data-pdp-stock]');
  var nameEl = $('[data-pdp-name]'), addBtn = form.querySelector('[name="add"]');
  var express = form.querySelector('[data-pdp-express]');
  var hintEl = form.querySelector('[data-pdp-hint]');
  var bar = document.querySelector('[data-pdp-bar]');
  var barPrice = bar && bar.querySelector('[data-pdp-bar-price]');
  var barAdd = bar && bar.querySelector('[data-pdp-bar-add]');
  var HINT = window.LLVariantHint;
  var names = groups.map(function (g) {
    var lab = document.getElementById(g.getAttribute('aria-labelledby'));
    return lab ? lab.textContent.trim() : '';
  });
  function hint(msg) {
    if (!hintEl) { return; }
    hintEl.textContent = msg || '';
    hintEl.hidden = !msg;
  }
  /* Cross out values that can't be bought with the other current choices. */
  function markAvail() {
    var now = chosen();
    groups.forEach(function (g, j) {
      g.querySelectorAll('[data-pdp-value]').forEach(function (b) {
        var trial = now.slice();
        trial[j] = b.getAttribute('data-pdp-value');
        var v = match(trial);
        if (!v) { b.setAttribute('data-avail', 'none'); }
        else if (!v.available) { b.setAttribute('data-avail', 'sold'); }
        else { b.removeAttribute('data-avail'); }
      });
    });
  }
  var skuEl = $('[data-pdp-sku]');
  var stage = $('[data-pdp-stage]');
  var shot = stage && stage.querySelector('[data-pdp-shot]');
  var count = stage && stage.querySelector('[data-pdp-count]');
  var thumbs = [].slice.call(document.querySelectorAll('[data-pdp-thumb]'));
  var navs = stage ? [].slice.call(stage.querySelectorAll('[data-pdp-step]')) : [];

  /* ---- gallery: `view` is the MEDIA indices for the current colour */
  var view = [], at = 0, colour = null;

  function show(n) {
    if (!shot || !view.length) { return; }
    at = (n + view.length) % view.length;
    var m = MEDIA[view[at]];
    shot.src = m.src;
    shot.alt = m.alt || '';
    if (count) { count.textContent = (at + 1) + ' / ' + view.length; }
    thumbs.forEach(function (t) {
      t.setAttribute('aria-pressed', String(+t.getAttribute('data-pdp-thumb') === view[at]));
    });
  }

  function setColour(c) {
    if (c === colour && view.length) { return; }
    colour = c;
    view = [];
    MEDIA.forEach(function (m, i) { if (!c || m.colour === c) { view.push(i); } });
    thumbs.forEach(function (t) { t.hidden = view.indexOf(+t.getAttribute('data-pdp-thumb')) < 0; });
    navs.forEach(function (b) { b.hidden = view.length < 2; });
    if (count) { count.hidden = view.length < 2; }
  }

  /* ---- variants */
  var grouped = MEDIA.some(function (m) { return m.colour; });

  function chosen() {
    return groups.map(function (g) {
      var on = g.querySelector('[aria-pressed="true"]');
      return on ? on.getAttribute('data-pdp-value') : null;
    });
  }

  /* Exact match first; else hold the pressed option and relax the rest. */
  function match(sel, pin) {
    function find(want) {
      for (var i = 0; i < VARIANTS.length; i++) {
        var v = VARIANTS[i], ok = true;
        for (var j = 0; j < want.length; j++) {
          if (want[j] !== null && v.options[j] !== want[j]) { ok = false; break; }
        }
        if (ok) { return v; }
      }
      return null;
    }
    var v = find(sel);
    if (v || pin == null) { return v; }
    var loose = sel.map(function (x, j) { return j === pin ? x : null; });
    return find(loose);
  }

  function press(v) {
    groups.forEach(function (g, j) {
      g.querySelectorAll('[data-pdp-value]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-pdp-value') === v.options[j]));
      });
    });
  }

  function paint(v, moveImage) {
    if (!v) { return; }
    if (select && select.value !== String(v.id)) {
      select.value = String(v.id);
      /* Express checkout buttons read the chosen variant from this field. */
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (express) { express.hidden = !v.available; }
    if (barPrice) { barPrice.textContent = v.price; }
    if (barAdd) { barAdd.textContent = v.available ? 'Add to cart' : 'Sold out'; barAdd.classList.toggle('is-off', !v.available); }
    if (HINT) { hint(v.available ? '' : HINT.soldOut(VARIANTS, v.options, names)); }
    if (priceEl) { priceEl.textContent = v.price; }
    if (wasEl) { wasEl.hidden = !v.on_sale; wasEl.textContent = v.on_sale ? v.compare_at : ''; }
    if (saveEl) { saveEl.hidden = !v.on_sale; saveEl.textContent = v.on_sale ? ('Save ' + v.saved + '%') : ''; }
    if (stockEl) {
      stockEl.innerHTML = v.available
        ? '<span class="dot dot--live"></span>In stock'
        : '<span class="dot"></span>Out of stock';
    }
    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    if (skuEl) {
      skuEl.textContent = v.sku || '';
      skuEl.parentNode.hidden = !v.sku;
    }
    if (nameEl && v.title && nameEl.textContent !== v.title) {
      document.title = document.title.replace(nameEl.textContent.trim(), v.title);
      nameEl.textContent = v.title;
      var crumb = document.querySelector('[data-pdp-crumb]');
      if (crumb) { crumb.textContent = v.title; }
    }

    var c = grouped ? v.options[0] : null;
    var changed = c !== colour;
    setColour(c);
    if (moveImage || changed) {
      var k = v.image != null ? view.indexOf(v.image) : -1;
      if (k > -1) { show(k); } else if (changed || !view.length) { show(0); }
    }

    try {
      var u = new URL(v.url || window.location.href, window.location.origin);
      u.search = window.location.search;
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u);
    } catch (e) {}
  }

  groups.forEach(function (g, pos) {
    g.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pdp-value]');
      if (!btn) { return; }
      var want = chosen();
      want[pos] = btn.getAttribute('data-pdp-value');
      var v = match(want, pos);
      if (!v) { return; }
      var exact = match(want);
      press(v);
      paint(v, true);
      markAvail();
      /* Say so when the picker had to change another option by itself. */
      if (!exact && v.available && HINT) { hint(HINT.switched(want, v.options, names, pos)); }
    });
  });

  /* Initial paint: honour ?variant= and the server-picked image. */
  var first = match(chosen());
  if (first) {
    setColour(grouped ? first.options[0] : null);
    var lead = thumbs.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; })[0];
    var k = lead ? view.indexOf(+lead.getAttribute('data-pdp-thumb')) : -1;
    show(k > -1 ? k : 0);
    paint(first, false);
    markAvail();
  }

  navs.forEach(function (b) {
    b.addEventListener('click', function () { show(at + parseInt(b.getAttribute('data-pdp-step'), 10)); });
  });
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { show(view.indexOf(+t.getAttribute('data-pdp-thumb'))); });
  });
  if (stage) {
    /* Swipe on touch screens. */
    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) { return; }
      var dx = e.changedTouches[0].clientX - sx;
      sx = null;
      if (Math.abs(dx) > 40) { show(at + (dx < 0 ? 1 : -1)); }
    }, { passive: true });
    stage.setAttribute('tabindex', '0');
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(at - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
    });
  }

  /* Sticky bar: up once the buy row has scrolled above the screen. Its
     button submits the real form, or takes the shopper back to the
     options when the current choice can't be bought. */
  if (bar && barAdd) {
    var row = form.querySelector('.pdp__act');
    /* A scroll check, not an observer: a jump from far down straight to the
       top (iOS status-bar tap) never crosses the row, so an observer would
       leave the bar up. */
    if (row) {
      var ticking = false;
      var place = function () {
        ticking = false;
        bar.classList.toggle('is-up', row.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(place); }
      }, { passive: true });
      place();
    }
    barAdd.addEventListener('click', function () {
      var v = match(chosen());
      if (!v || !v.available) {
        row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (HINT) { hint(v ? HINT.soldOut(VARIANTS, v.options, names) : 'Choose an option for each setting above.'); }
        return;
      }
      if (form.requestSubmit) { form.requestSubmit(); } else { addBtn && addBtn.click(); }
    });
  }

  /* Cart API + drawer; the form still POSTs natively without fetch. */
  form.addEventListener('submit', function (e) {
    if (!window.fetch) { return; }
    e.preventDefault();
    var v = match(chosen());
    if (!v || !v.available) {
      if (HINT) { hint(v ? HINT.soldOut(VARIANTS, v.options, names) : 'Choose an option for each setting above.'); }
      return;
    }
    var qty = form.querySelector('[name="quantity"]');
    if (addBtn) { addBtn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: parseInt(qty && qty.value, 10) || 1 })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.body && res.body.description || 'Could not add to cart'); }
        hint('');
        document.dispatchEvent(new CustomEvent('cart:changed'));
        var open = document.querySelector('[data-open-cart]');
        if (open) { setTimeout(function () { open.click(); }, 120); }
      })
      .catch(function (err) {
        /* Say what went wrong (e.g. a stock limit) instead of failing quietly. */
        hint(err && err.message ? err.message : 'Couldn\'t add that to the cart. Please try again.');
      })
      .then(function () { if (addBtn) { addBtn.disabled = !v.available; } });
  });
}());

/* Quick order: quantity grid -> one /cart/add.js request. */
(function () {
  var root = document.querySelector('[data-qo]');
  if (!root) { return; }
  var inputs = [].slice.call(root.querySelectorAll('[data-qo-id]'));
  var items = [].slice.call(root.querySelectorAll('[data-qo-item]'));
  var bar = root.querySelector('[data-qo-bar]');
  var unitsEl = root.querySelector('[data-qo-units]');
  var unitLab = root.querySelector('[data-qo-unitlab]');
  var totalEl = root.querySelector('[data-qo-total]');
  var addBtn = root.querySelector('[data-qo-add]');
  var msg = root.querySelector('[data-qo-msg]');
  var shown = root.querySelector('[data-qo-shown]');
  var empty = root.querySelector('[data-qo-empty]');
  var fmt = '${{amount}}';
  try { fmt = JSON.parse(root.querySelector('[data-qo-money]').textContent) || fmt; } catch (e) {}

  function money(cents) {
    var n = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  }
  function qty(i) { var n = parseInt(i.value, 10); return n > 0 ? Math.min(n, 999) : 0; }
  function say(text, ok) {
    msg.textContent = text || '';
    msg.hidden = !text;
    msg.classList.toggle('is-ok', !!ok);
  }

  function tally() {
    var units = 0, cents = 0;
    inputs.forEach(function (i) {
      var n = qty(i);
      units += n;
      cents += n * parseInt(i.getAttribute('data-qo-price'), 10);
      i.closest('td').classList.toggle('is-set', n > 0);
    });
    unitsEl.textContent = units;
    unitLab.textContent = units === 1 ? unitLab.dataset.one : unitLab.dataset.many;
    totalEl.textContent = money(cents);
    addBtn.disabled = units === 0;
    bar.classList.toggle('is-up', units > 0);
  }

  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-qo-id]')) { say(''); tally(); }
  });

  root.querySelector('[data-qo-search]').addEventListener('input', function (e) {
    var q = e.target.value.trim().toLowerCase();
    var n = 0;
    items.forEach(function (it) {
      var hit = !q || it.getAttribute('data-qo-text').indexOf(q) !== -1;
      it.hidden = !hit;
      if (hit) { n++; }
    });
    shown.textContent = n + ' ' + (n === 1 ? shown.dataset.one : shown.dataset.many);
    empty.hidden = n > 0;
  });

  root.querySelector('[data-qo-clear]').addEventListener('click', function () {
    inputs.forEach(function (i) { i.value = ''; });
    say('');
    tally();
  });

  addBtn.addEventListener('click', function () {
    var list = inputs.filter(function (i) { return qty(i) > 0; }).map(function (i) {
      return { id: +i.getAttribute('data-qo-id'), quantity: qty(i) };
    });
    if (!list.length) { return; }
    addBtn.disabled = true;
    say('');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: list })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.body && (res.body.description || res.body.message) || 'Could not add to cart'); }
        inputs.forEach(function (i) { i.value = ''; });
        tally();
        document.dispatchEvent(new CustomEvent('cart:changed'));
        var open = document.querySelector('[data-open-cart]');
        if (open) { setTimeout(function () { open.click(); }, 120); }
      })
      .catch(function (err) {
        /* Keep the quantities so the shopper can fix one line and retry. */
        say(err.message);
        addBtn.disabled = false;
      });
  });

  tally();
}());

/* Product page size guide: native <dialog>, so focus and Escape are handled. */
(function () {
  var dlg = document.querySelector('[data-size-guide]');   /* first one wins if a page renders several */
  if (!dlg || typeof dlg.showModal !== 'function') { return; }
  document.querySelectorAll('[data-size-guide-open]').forEach(function (b) {
    b.addEventListener('click', function () { dlg.showModal(); });
  });
  dlg.querySelector('[data-size-guide-close]').addEventListener('click', function () { dlg.close(); });
  /* A click on the backdrop lands on the dialog itself. */
  dlg.addEventListener('click', function (e) { if (e.target === dlg) { dlg.close(); } });
}());

/* HERO SHOWCASE · scroll picks the slide. Background crossfades; the
   outgoing product drifts up-left and fades; the incoming one glides in
   from the "next" thumbnail, already large. Reverse plays backwards. */
(function () {
  'use strict';
  var stage = document.querySelector('[data-show]');
  if (!stage) { return; }
  var root = stage.querySelector('[data-show-root]');
  var data = [];
  try { data = JSON.parse(stage.querySelector('[data-show-slides]').textContent) || []; } catch (e) {}
  var N = data.length;
  if (!N) { return; }

  var $ = function (s) { return root.querySelector(s); };
  var imgs = [].slice.call(root.querySelectorAll('[data-show-img]'));
  var bgs = [].slice.call(root.querySelectorAll('[data-show-bg]'));
  var el = {
    eyebrow: $('[data-show-eyebrow]'), title: $('[data-show-title]'), text: $('[data-show-text]'),
    cta: $('[data-show-cta]'), ctat: $('[data-show-ctat]'),
    price: $('[data-show-price]'), was: $('[data-show-was]'), sizes: $('[data-show-sizes]'), sizelab: $('[data-show-sizelab]'),
    colours: $('[data-show-colours]'), collab: $('[data-show-collab]'),
    buy: $('[data-show-buy]'), from: $('[data-show-from]'), quick: $('[data-show-quick]'),
    bal: $('[data-show-bal]'), bav: $('[data-show-bav]'), bbl: $('[data-show-bbl]'), bbv: $('[data-show-bbv]'),
    badges: [].slice.call(root.querySelectorAll('[data-show-badge]')), next: $('[data-show-next]'), thumb: $('[data-show-thumb]'), shadow: $('[data-show-shadow]'),
    copy: root.querySelector('.show__copy'),
    head: document.querySelector('[data-head-over]'), ann: document.querySelector('[data-ann]')
  };
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DUR = 1000;
  var GLIDE = 'cubic-bezier(.22,.61,.36,1)', DRIFT = 'cubic-bezier(.45,0,.25,1)';
  var UP = 'translate(-14%, -64%) scale(0.48)';
  var cur = -1;

  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function copy(s) {
    if (el.eyebrow) { el.eyebrow.textContent = s.eyebrow || ''; }
    el.title.innerHTML = s.title || '';             /* merchant setting, rendered by the theme */
    if (el.text) { el.text.textContent = s.sub || ''; }
    if (el.ctat) { el.ctat.textContent = s.cta || ''; }
    if (el.cta) { el.cta.setAttribute('href', s.href || '#'); }
    if (el.price) { el.price.textContent = s.price || ''; }
    if (el.from) { el.from.hidden = !s.from; }
    if (el.bal) { el.bal.textContent = s.bal || ''; el.bav.textContent = s.bav || ''; el.bal.closest('[data-show-badge]').hidden = !s.bav; }
    if (el.bbl) { el.bbl.textContent = s.bbl || ''; el.bbv.textContent = s.bbv || ''; el.bbl.closest('[data-show-badge]').hidden = !s.bbv; }
    if (el.quick) { el.quick.hidden = !s.handle; el.quick.setAttribute('data-site-quick', s.handle || ''); }
    if (el.was) { el.was.textContent = s.was || ''; }
    var sizes = s.sizes || [];
    if (el.sizes) {
      el.sizes.innerHTML = sizes.map(function (z) {
        return '<a class="show__size" role="listitem" href="' + esc(z.url) + '" aria-label="' + esc(z.name) + '">' + esc(z.label) + '</a>';
      }).join('');
    }
    if (el.sizelab) { el.sizelab.hidden = !sizes.length; }
    var colours = s.colours || [];
    if (el.colours) {
      el.colours.innerHTML = colours.map(function (c) {
        var dot = '<span class="show__dot" style="--sw:' + esc(c.hex) + '"></span>';
        if (c.current || !c.url) {
          return '<span class="show__colour" role="listitem" title="' + esc(c.name) + '"' + (c.current ? ' aria-current="true"' : '') + '>' + dot + '<span class="visually-hidden">' + esc(c.name) + '</span></span>';
        }
        return '<a class="show__colour" role="listitem" href="' + esc(c.url) + '" title="' + esc(c.name) + '" aria-label="' + esc(c.name) + '">' + dot + '</a>';
      }).join('');
      el.colours.hidden = !colours.length;
    }
    if (el.collab) { el.collab.hidden = !colours.length; }
    if (el.buy) { el.buy.hidden = !s.price && !sizes.length && !colours.length; }
    if (s.accent) { root.style.setProperty('--tc-accent', s.accent); root.style.setProperty('--tc-on-accent', onColour(s.accent)); }
    if (s.title_c) { root.style.setProperty('--tc-title', s.title_c); }
    if (s.text_c) { root.style.setProperty('--tc-text', s.text_c); }
    root.classList.toggle('is-light', !!s.light);
    if (el.head) { el.head.classList.toggle('is-onDark', !s.light); }
  }

  /* Readable ink for anything sitting on the accent colour. */
  function onColour(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex).trim());
    if (!m) { return '#0b0c0d'; }
    var n = parseInt(m[1], 16), r = (n >> 16) / 255, g = (n >> 8 & 255) / 255, b = (n & 255) / 255;
    var lin = function (c) { return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
    return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b) > 0.4 ? '#0b0c0d' : '#ffffff';
  }

  function setThumb(i) {
    if (el.thumb) { el.thumb.src = data[(i + 1) % N].img || ''; }
  }

  /* Transform that puts `target` where the thumbnail is, at a given scale. */
  function atThumb(target, scale) {
    var t = el.next && el.next.offsetParent ? el.next.getBoundingClientRect() : null;
    var r = target.getBoundingClientRect();
    if (!t || !r.width) { return 'translate(0, 45%) scale(' + scale + ')'; }
    return 'translate(' + Math.round(t.left + t.width / 2 - (r.left + r.width / 2)) + 'px,' +
      Math.round(t.top + t.height * 0.35 - (r.top + r.height / 2)) + 'px) scale(' + scale + ')';
  }

  /* Desktop: the product leaves towards the header logo (and returns from it). */
  var desk = window.matchMedia('(min-width: 1025px)');
  function toLogo(target) {
    var logo = document.querySelector('[data-head] .head__logo');
    var r = target.getBoundingClientRect();
    if (!desk.matches || !logo || !r.width) { return UP; }
    var l = logo.getBoundingClientRect();
    var s = Math.max(0.06, Math.min(0.3, (l.height * 2.2) / r.height));
    return 'translate(' + Math.round(l.left + l.width / 2 - (r.left + r.width / 2)) + 'px,' +
      Math.round(l.top + l.height / 2 - (r.top + r.height / 2)) + 'px) scale(' + s.toFixed(3) + ')';
  }

  function settle(i) {
    imgs.forEach(function (m, k) { m.classList.toggle('is-on', k === i); if (k === i) { m.removeAttribute('aria-hidden'); } else { m.setAttribute('aria-hidden', 'true'); } });
    bgs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.style.zIndex = ''; });
  }

  function paint(i, dir) {
    if (i === cur) { return; }
    var prev = cur;
    cur = i;
    var s = data[i];
    [].concat(imgs, bgs, el.badges, [el.thumb, el.shadow, el.copy]).forEach(function (n) {
      if (n) { n.getAnimations().forEach(function (a) { a.finish(); }); }
    });

    if (prev === -1 || still.matches) { settle(i); copy(s); setThumb(i); return; }

    var out = imgs[prev], inn = imgs[i];
    inn.classList.add('is-on');
    var fwd = dir > 0;

    out.animate(fwd
      ? [{ transform: 'none', opacity: 1 }, { opacity: 0.6, offset: 0.55 }, { transform: toLogo(out), opacity: 0 }]
      : [{ transform: 'none', opacity: 1 }, { transform: atThumb(out, 0.6), opacity: 0 }],
      { duration: DUR * 0.9, easing: DRIFT }).onfinish = function () { if (cur !== prev) { out.classList.remove('is-on'); } };
    inn.animate(fwd
      ? [{ transform: atThumb(inn, 0.62), opacity: 1 }, { transform: 'none', opacity: 1 }]
      : [{ transform: toLogo(inn), opacity: 0 }, { transform: 'none', opacity: 1 }],
      { duration: DUR, easing: GLIDE });

    var bIn = bgs[i];
    bgs.forEach(function (b) { b.style.zIndex = ''; });
    bIn.style.zIndex = 1;
    bIn.classList.add('is-on');
    bIn.animate([{ opacity: 0 }, { opacity: 1 }], { duration: DUR, easing: 'linear' }).onfinish = function () { if (cur === i) { settle(i); } };

    if (el.shadow) {
      el.shadow.animate([{ opacity: 1 }, { opacity: 0, offset: 0.25 }, { opacity: 0, offset: 0.75 }, { opacity: 1 }], { duration: DUR });
    }
    if (el.thumb) {
      el.thumb.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, fill: 'forwards' }).onfinish = function () {
        setThumb(i);
        el.thumb.animate([{ opacity: 0, transform: 'translateY(18px) scale(.9)' }, { opacity: 1, transform: 'none' }],
          { duration: 420, delay: DUR * 0.85, easing: GLIDE, fill: 'both' });
      };
    }
    el.badges.forEach(function (b, k) {
      b.animate([{ opacity: 1 }, { opacity: 0, offset: 0.2 }, { opacity: 0, offset: 0.7 }, { opacity: 1 }],
        { duration: DUR + 200 + k * 120, easing: 'ease-out' });
    });
    if (el.copy) {
      el.copy.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-10px)' }],
        { duration: 220, easing: DRIFT }).onfinish = function () {
          copy(s);
          el.copy.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }],
            { duration: 480, easing: GLIDE });
        };
    } else { copy(s); }
  }

  /* Scroll: equal segment per slide, small dead band against boundary flicker. */
  function travel() { return Math.max(1, stage.offsetHeight - window.innerHeight); }
  var ticking = false;
  function read() {
    ticking = false;
    var p = Math.min(1, Math.max(0, -stage.getBoundingClientRect().top / travel()));
    var f = p * N;
    var i = Math.min(N - 1, Math.floor(f));
    if (cur > -1 && Math.abs(i - cur) === 1 && Math.abs(f - (i > cur ? i : cur)) < 0.15) { i = cur; }
    paint(i, i > cur ? 1 : -1);
    if (el.ann) { el.ann.classList.toggle('is-retracted', window.scrollY > 40); }
    if (el.head) { el.head.classList.toggle('is-landed', f >= N - 0.5); }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(read); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  function goTo(i) {
    i = (i + N) % N;
    if (still.matches) { paint(i, i > cur ? 1 : -1); return; }
    var top = stage.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: top + ((i + 0.5) / N) * travel(), behavior: 'smooth' });
  }
  var prevBtn = $('[data-show-prev]'), stepBtn = $('[data-show-step]');
  if (prevBtn) { prevBtn.addEventListener('click', function () { goTo(cur - 1); }); }
  if (stepBtn) { stepBtn.addEventListener('click', function () { goTo(cur + 1); }); }
  if (el.next) { el.next.addEventListener('click', function () { goTo(cur + 1); }); }

  /* One gesture = one slide while the hero is pinned (like a full-page
     slider). Input is held until the move finishes AND the gesture stops,
     so trackpad momentum cannot skip slides. At either end the page
     scrolls on normally. */
  var busyUntil = 0, lastWheel = 0;
  function pinned() {
    var r = stage.getBoundingClientRect();
    return r.top <= 1 && r.bottom >= window.innerHeight - 1;
  }
  function step(dir, e) {
    var target = cur + dir;
    if (target < 0 || target >= N || !pinned()) { return false; }   /* let the page leave the hero */
    if (e && e.cancelable) { e.preventDefault(); }
    var now = Date.now();
    if (now < busyUntil) { return true; }
    busyUntil = now + DUR + 150;
    goTo(target);
    return true;
  }
  window.addEventListener('wheel', function (e) {
    if (still.matches || Math.abs(e.deltaY) < 4) { return; }
    var now = Date.now(), gap = now - lastWheel;
    lastWheel = now;
    var dir = e.deltaY > 0 ? 1 : -1;
    if (!pinned() || (cur + dir < 0) || (cur + dir >= N)) { return; }
    e.preventDefault();
    if (now < busyUntil || gap < 160 && busyUntil > now - 400) { busyUntil = Math.max(busyUntil, now + 120); return; }
    step(dir, e);
  }, { passive: false });

  var ty = null;
  stage.addEventListener('touchstart', function (e) { ty = e.touches[0].clientY; }, { passive: true });
  stage.addEventListener('touchmove', function (e) {
    if (ty === null || still.matches) { return; }
    var dy = ty - e.touches[0].clientY;
    if (Math.abs(dy) < 8) { return; }
    var dir = dy > 0 ? 1 : -1;
    if (pinned() && cur + dir >= 0 && cur + dir < N && e.cancelable) { e.preventDefault(); }
  }, { passive: false });
  stage.addEventListener('touchend', function (e) {
    if (ty === null) { return; }
    var dy = ty - e.changedTouches[0].clientY;
    ty = null;
    if (Math.abs(dy) > 40) { step(dy > 0 ? 1 : -1, null); }
  }, { passive: true });

  document.addEventListener('keydown', function (e) {
    if (!pinned() || /INPUT|TEXTAREA|SELECT/.test((document.activeElement || {}).tagName || '')) { return; }
    if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') { step(1, e); }
    if (e.key === 'ArrowUp' || e.key === 'PageUp') { step(-1, e); }
  });

  function measureHead() {
    var h = document.querySelector('[data-head]');
    if (h) { document.documentElement.style.setProperty('--head-real', Math.round(h.getBoundingClientRect().height) + 'px'); }
  }
  measureHead();
  window.addEventListener('resize', measureHead, { passive: true });

  read();
})();
